export default function travelExpense(
    vehicleType: string,
    cv: number,
    distance: number,
    isElectric: boolean,
): any {
    let coef = 0;
    let fixAmount = 0;

    if (vehicleType === "CAR") {
        // "CAR" -> Voiture
        if (distance <= 5000) {
            if (cv <= 3) {
                coef = 0.502;
            } else if (cv === 4) {
                coef = 0.575;
            } else if (cv === 5) {
                coef = 0.603;
            } else if (cv === 6) {
                coef = 0.631;
            } else {
                coef = 0.661;
            }
        } else if (distance <= 20000) {
            if (cv <= 3) {
                coef = 0.3;
                fixAmount = 1007;
            } else if (cv === 4) {
                coef = 0.323;
                fixAmount = 1262;
            } else if (cv === 5) {
                coef = 0.339;
                fixAmount = 1320;
            } else if (cv === 6) {
                coef = 0.355;
                fixAmount = 1382;
            } else {
                coef = 0.374;
                fixAmount = 1435;
            }
        } else {
            if (cv <= 3) {
                coef = 0.35;
            } else if (cv === 4) {
                coef = 0.387;
            } else if (cv === 5) {
                coef = 0.405;
            } else if (cv === 6) {
                coef = 0.425;
            } else {
                coef = 0.446;
            }
        }
    } else if (vehicleType === "TWO_REAR_WHEELS_GT_50") {
        // "TWO_REAR_WHEELS_GT_50" -> Moto > 50cm3 / Motocyclettes
        if (distance <= 3000) {
            if (cv === 1 || cv === 2) {
                coef = 0.375;
            } else if (cv === 3 || cv === 4 || cv === 5) {
                coef = 0.444;
            } else {
                coef = 0.575;
            }
        } else if (distance <= 6000) {
            if (cv === 1 || cv === 2) {
                coef = 0.094;
                fixAmount = 845;
            } else if (cv === 3 || cv === 4 || cv === 5) {
                coef = 0.078;
                fixAmount = 1099;
            } else {
                coef = 0.075;
                fixAmount = 1502;
            }
        } else {
            if (cv === 1 || cv === 2) {
                coef = 0.234;
            } else if (cv === 3 || cv === 4 || cv === 5) {
                coef = 0.261;
            } else {
                coef = 0.325;
            }
        }
    } else if (vehicleType === "TWO_REAR_WHEELS_LTE_50") {
        // "TWO_REAR_WHEELS_LTE_50" -> Moto <= 50cm3 / Cyclomoteurs
        if (distance <= 3000) {
            coef = 0.299;
        } else if (distance <= 6000) {
            coef = 0.07;
            fixAmount = 458;
        } else {
            coef = 0.162;
        }
    } else if (vehicleType === "BICYCLE") {
        // "BICYCLE" -> Vélo
        coef = 0.25;
    }

    let travelExpense = distance * coef + fixAmount;

    if (isElectric && vehicleType !== "BICYCLE") {
        travelExpense = travelExpense * 1.2;
    }

    return {
        travelExpenseAmount: travelExpense,
        coef: coef,
        fixAmount: fixAmount,
    };
}
